import React from 'react';

type Platform = 'instagram' | 'tiktok' | 'youtube' | 'twitter' | 'facebook' | 'whatsapp' | 'telegram';

interface PlatformBadgeProps {
  platform: Platform;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const platformConfig: Record<Platform, { label: string; icon: string; bgClass: string; textColor: string }> = {
  instagram: {
    label: 'Instagram',
    icon: 'IG',
    bgClass: 'platform-badge-instagram',
    textColor: 'text-white',
  },
  tiktok: {
    label: 'TikTok',
    icon: 'TK',
    bgClass: 'platform-badge-tiktok',
    textColor: 'text-white',
  },
  youtube: {
    label: 'YouTube',
    icon: 'YT',
    bgClass: 'platform-badge-youtube',
    textColor: 'text-white',
  },
  twitter: {
    label: 'X (Twitter)',
    icon: 'X',
    bgClass: 'platform-badge-twitter',
    textColor: 'text-white',
  },
  facebook: {
    label: 'Facebook',
    icon: 'FB',
    bgClass: 'platform-badge-facebook',
    textColor: 'text-white',
  },
  whatsapp: {
    label: 'WhatsApp',
    icon: 'WA',
    bgClass: 'bg-green-600',
    textColor: 'text-white',
  },
  telegram: {
    label: 'Telegram',
    icon: 'TG',
    bgClass: 'bg-blue-500',
    textColor: 'text-white',
  },
};

const fallbackConfig = {
  label: 'Unknown',
  icon: '?',
  bgClass: 'bg-muted',
  textColor: 'text-muted-foreground',
};

export default function PlatformBadge({ platform, size = 'md', showLabel = false, className = '' }: PlatformBadgeProps) {
  const config = platformConfig[platform] ?? fallbackConfig;
  const sizeClasses = {
    sm: 'w-5 h-5 text-xs rounded',
    md: 'w-6 h-6 text-xs rounded-md',
    lg: 'w-8 h-8 text-sm rounded-lg',
  };

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`}>
      <span
        className={`flex items-center justify-center font-700 flex-shrink-0 ${config.bgClass} ${config.textColor} ${sizeClasses[size]}`}
      >
        {config.icon}
      </span>
      {showLabel && (
        <span className="text-sm text-foreground font-500">{config.label}</span>
      )}
    </div>
  );
}